import React, { useState, useMemo, ReactNode, useEffect } from 'react';
import AuthContext from '../context/AuthContext';

// Define types for user data (removed password for security; use token instead)
type UserData = {
  username: string;
  token: string;
  isAuthenticated: boolean;
};

// Define props type for AuthProvider
type AuthProviderProps = {
  children: ReactNode;
};

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
    const [userData, setUserData] = useState<UserData>({ 
        username: "", 
        token: "",
        isAuthenticated: false
    });

    // Load user data from localStorage on mount
    useEffect(() => {
        const storedToken = localStorage.getItem("valuation_token");
        const storedUser = localStorage.getItem("valuation_user");

        if (storedToken && storedUser) {
            const user = JSON.parse(storedUser);
            setUserData({ 
                username: user.username || "", 
                token: storedToken,
                isAuthenticated: true
            });
        }
    }, []);

    // Login function with proper typing (call this after successful fetch)
    const login = (username: string, token: string): void => {
        setUserData({ 
            username, 
            token,
            isAuthenticated: true
        });
    };

    // Logout function (clear state and all localStorage data)
    const logout = (): void => {
        setUserData({ 
            username: "", 
            token: "",
            isAuthenticated: false
        });
        localStorage.clear(); // Clears all localStorage data
    };

    // Memoized context value
    const value = useMemo(() => ({
        userData,
        login,
        logout
    }), [userData]);

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;